import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6v15","key":"svg-0"}],["path",{"d":"M9 18l3 3l3 -3","key":"svg-1"}],["path",{"d":"M9 3l3 3l3 -3","key":"svg-2"}]]

const IconArrowDownTail = createReactComponent('outline', 'arrow-down-tail', 'ArrowDownTail', __iconNode);

export default IconArrowDownTail;